import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { CheckCircle, XCircle, Tv } from 'lucide-react';
import LoginButton from '../LoginButton';
import { api } from '../api';

const STORAGE_KEY = 'pendingPairToken';

// Reachable at /pair?token=... (the URL encoded in the QR shown on the TV).
// If the user isn't signed in we stash the token, send them through Auth0, and
// resume the claim when they return.
export default function PairView({ onDone }) {
  const { isAuthenticated, isLoading, user } = useAuth0();
  const [status, setStatus] = useState('working'); // working | success | error | needauth
  const [message, setMessage] = useState('Pairing your TV…');

  const token =
    new URLSearchParams(window.location.search).get('token') ||
    localStorage.getItem(STORAGE_KEY);

  useEffect(() => {
    if (token) localStorage.setItem(STORAGE_KEY, token);
  }, [token]);

  useEffect(() => {
    if (isLoading) return;
    if (!token) { setStatus('error'); setMessage('No pairing token found.'); return; }
    if (!isAuthenticated) { setStatus('needauth'); setMessage('Sign in to finish pairing this TV.'); return; }

    (async () => {
      try {
        await api.claimPairing(token, user.sub, user.email);
        localStorage.removeItem(STORAGE_KEY);
        setStatus('success');
        setMessage('TV paired! It will show your content shortly.');
      } catch (e) {
        setStatus('error');
        setMessage(e.message || 'Pairing failed.');
      }
    })();
  }, [isLoading, isAuthenticated, token, user]);

  return (
    <div className="app-container">
      <div className="main-card-wrapper">
        <h1 className="main-title"><Tv size={28} style={{ verticalAlign: 'middle', marginRight: 8 }} />Pair TV</h1>
        <div className="action-card" style={{ textAlign: 'center' }}>
          {status === 'working' && <p className="action-text">{message}</p>}
          {status === 'needauth' && (<><p className="action-text">{message}</p><LoginButton /></>)}
          {status === 'success' && (
            <><CheckCircle size={48} color="#22c55e" /><p className="action-text">{message}</p>
              <button className="button" onClick={onDone}>Go to dashboard</button></>
          )}
          {status === 'error' && (
            <><XCircle size={48} color="#ef4444" /><p className="action-text">{message}</p>
              <button className="button" onClick={onDone}>Back to dashboard</button></>
          )}
        </div>
      </div>
    </div>
  );
}
